import './../sass/style.scss';
import 'bootstrap';
import fontawesome from '@fortawesome/fontawesome';
import light from '@fortawesome/fontawesome-pro-light';
import brands from '@fortawesome/fontawesome-free-brands';
import Flickity from 'flickity';
import 'lightgallery/dist/js/lightgallery-all';
import 'lazysizes/lazysizes.min.js';
import 'flickity-bg-lazyload/bg-lazyload.js';


fontawesome.library.add(light);

jQuery(function ($) {
	"use strict";

	function myAddParameterAndReturn(url, paramName, paramValue)
	{
	    if (url.indexOf(paramName + "=") >= 0)
	    {
	        var prefix = url.substring(0, url.indexOf(paramName));
	        var suffix = url.substring(url.indexOf(paramName));
	        suffix = suffix.substring(suffix.indexOf("=") + 1);
	        suffix = (suffix.indexOf("&") >= 0) ? suffix.substring(suffix.indexOf("&")) : "";
	        url = prefix + paramName + "=" + paramValue + suffix;
	    }
	    else
	    {
	    if (url.indexOf("?") < 0)
	        url += "?" + paramName + "=" + paramValue;
	    else
	        url += "&" + paramName + "=" + paramValue;
	    }
	    return url;
	}

	var geoMarkers = [];
	var googleMapMarkers = [];
	var markerCluster = [];
	

	function requestMarkers(map, url){
	    deleteMarkers();

	    $.ajax({
	      dataType: "json",
	      url: url,
	    }).done(function(json) {
	      $.each(json, function(index, elem){
	        geoMarkers.push({
	             "type": "Feature",
	             "geometry": {
	                 "type": "Point",
	                 "coordinates": [
	                     elem.address.lng,
	                     elem.address.lat
	                 ]
	             },
	             "properties": {
	                 "postid" : elem.post.ID,
	                 "link": elem.permalink,
	                 "marker": elem.markerIcon
	             }
	         });
	      })
	    setMarkers(map, geoMarkers);

	    }).always(function(){
	       // console.log("request complete");
	    })

	}
	

	function setMarkers(map, geoMarkers){
	    var geojson =
	    {
	        "type": "FeatureCollection",
	        "features": geoMarkers
	        
	    };
		
	    
	    //console.log(geojson);
	    if (geojson.features.length >= 1) {
	        var bounds = new google.maps.LatLngBounds();	        
	        
	        geojson.features.forEach(function(feature) {
	          if (feature.geometry.coordinates[1] && feature.geometry.coordinates[0]) {
	            var icon = new google.maps.MarkerImage(
	                        feature.properties.marker,
	                        new google.maps.Size(34,44),
	                        null,
	                        null,
	                        new google.maps.Size(34,44)
	                    );
	            
	            var markerpos = new google.maps.LatLng(feature.geometry.coordinates[1], feature.geometry.coordinates[0]);
	            var marker = new google.maps.Marker({
	              position: {
	              	lat: parseFloat(feature.geometry.coordinates[1]),
	              	lng: parseFloat(feature.geometry.coordinates[0])
	              }
	            });
	            marker.setIcon(icon);
	            googleMapMarkers.push(marker);

	          	 if($('.noLinks')[0]){

	          	 } else{
	          	 	google.maps.event.addListener(marker, 'click', function() {
		                window.open(feature.properties.link);
		             });
	          	 }

	            bounds.extend(markerpos);
	            }
	        });

	        class CustomClusterRenderer extends markerClusterer.DefaultRenderer {
				render({ count, position }) {
					const svg = `<svg version="1.1" id="Ebene_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
						viewBox="0 0 43 74.2" style="enable-background:new 0 0 43 74.2;" xml:space="preserve">
					<style type="text/css">
						.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#C6783F;}
					</style>
					<g id="Objektdetail-Copy" transform="translate(-701.000000, -2993.000000)">
						<g id="ic_location_on" transform="translate(685.000000, 2987.000000)">
							<path id="Icon" class="st0" d="M37.5,20.2c-11.9,0-21.5,9.4-21.5,21c0,15.8,21.5,39,21.5,39S59,57,59,41.2
								C59,29.6,49.4,20.2,37.5,20.2L37.5,20.2z M37.5,48.7"/>
						</g>
					</g>
					<text x="50%" y="55%" style="fill:#fff" text-anchor="middle" font-size="20" dominant-baseline="middle" font-family="roboto,arial,sans-serif">${count}</text>
					</svg>
					`;
		
					const title = `Cluster of ${count} markers`;
					const zIndex = Number(google.maps.Marker.MAX_ZINDEX) + count;
		
					const clusterOptions = {
						position,
						zIndex,
						title,
						icon: {
							url: `data:image/svg+xml;base64,${btoa(svg)}`,
							anchor: new google.maps.Point(15, 26),
							scaledSize: new google.maps.Size(30, 52),
						},
					};
		
					return new google.maps.Marker(clusterOptions);
				}
			}

			markerCluster = new markerClusterer.MarkerClusterer({
				map,
				markers: googleMapMarkers,
				gridSize: 50,
				maxZoom: 15,
				renderer: new CustomClusterRenderer(),
			});




	        google.maps.event.trigger(map, "resize");
	        $('.loadingOverlay').hide();
	        if (geoMarkers.length > 1) {
	          map.fitBounds(bounds);
	          setTimeout(function(){
	          	map.setZoom(map.getZoom());
	          }, 100)
	          
	        } else {
	          map.fitBounds(bounds);
	          map.setZoom(12);
	        }
	    };
	}

	function deleteMarkers() {
	    for(var i=0; i<googleMapMarkers.length; i++){
	    	markerCluster.removeMarker(googleMapMarkers[i]);
	    }
	    googleMapMarkers = [];
	    geoMarkers  = [];
	}

	function preventDefault(e) {
	  e = e || window.event;
	  if (e.preventDefault)
	      e.preventDefault();
	  e.returnValue = false;  
	}

	function keydown(e) {
	    for (var i = keys.length; i--;) {
	        if (e.keyCode === keys[i]) {
	            preventDefault(e);
	            return;
	        }
	    }
	}


	function wheel(e) {
	  preventDefault(e);
	}

	function disable_scroll() {
	  if (window.addEventListener) {
	      window.addEventListener('DOMMouseScroll', wheel, false);
	  }
	  window.onmousewheel = document.onmousewheel = wheel;
	  document.onkeydown = keydown;
	}

	function enable_scroll() {
	    if (window.removeEventListener) {
	        window.removeEventListener('DOMMouseScroll', wheel, false);
	    }
	    window.onmousewheel = document.onmousewheel = document.onkeydown = null;  
	}	

	function isScrolledIntoView(elem) {
	    var docViewTop = $(window).scrollTop();
	    var docViewBottom = docViewTop + $(window).height();

	    var elemTop = $(elem).offset().top;
	    var elemBottom = elemTop + $(elem).height();

	    return ((elemTop <= (docViewTop + $(window).height())));
	}
	function revealElements() {
		$('.reveal, .fadereveal').each(function () {
		var $revealElement = $(this);
		if (isScrolledIntoView($revealElement) === true) {
	   		if ($revealElement.data('delay')) {
	        	setTimeout(function(){
	            	$($revealElement).addClass('revealed');
	       		}, $revealElement.data('delay'));
	        } else {
                setTimeout(function(){
                    $($revealElement).addClass('revealed');
                }, 0);
            }
	        }
	    });
	}
	
	

	function fadeRevealElements() {
		$('.fadeReveal').each(function () {
		var $revealElement = $(this);
		if (isScrolledIntoView($revealElement) === true) {
	   		if ($revealElement.data('delay')) {
	        	setTimeout(function(){
	            	$($revealElement).addClass('fadeRevealed');
	       		}, $revealElement.data('delay'));
	        } else {
                setTimeout(function(){
                    $($revealElement).addClass('fadeRevealed');
                }, 0);
            }
	        }
	    });
	}

	$(window).on('scroll', function(){
		var offset = $(window).scrollTop();
		if(window.matchMedia("(max-width: 990px)").matches){
			var headerHeight = $('#header').outerHeight();
		} else{
			var headerHeight = $('#header').outerHeight();
		}
		if (offset >= headerHeight && $('.kontakt-stoerer').hasClass('nav-stoerer--active')) {
			$('.kontakt-stoerer').removeClass('nav-stoerer--active');
			if (!$('.bewerten-stoerer-ribbon').hasClass('bewerten-stoerer-ribbon--active')) {
				$('.bewerten-stoerer-ribbon').addClass('bewerten-stoerer-ribbon--active');
			}
		} 
		else if(offset < headerHeight){
			 $('.kontakt-stoerer').addClass('nav-stoerer--active');
		}
	})

	$('.toBottom').on('click', function(){
		$('html, body').animate({
			scrollTop: $('#content').offset().top -107-40
		}, 1000);
	})

	revealElements();
	$(window).on('scroll', function(){
		revealElements();
	});

	document.addEventListener('lazybeforeunveil', function(e){
		var bg = e.target.getAttribute('data-bg');
		if(bg){
			e.target.style.backgroundImage = 'url(' + bg + ')';
		}
	});	
	if (window.location.href.indexOf("/immobilien/") > -1) {
		$('a[href*="/immobilien/"]').parent().addClass('current-menu-ancestor current-menu-parent');
	}
	

	lazySizes.autoSizer.checkElems();

	revealElements();
	fadeRevealElements();
	
	$(window).on('scroll', function(){
		revealElements();
		fadeRevealElements();
	});

	if ($('.main-carousel').length){
		var	x = 1;
		$('.main-carousel').each(function(index, cl){
			$(this).addClass('carousel-'+index);
			//console.log(cl);
			x++;
			new Flickity(cl, {
				cellAlign: "left",
				contain: true,
				imagesLoaded: true,
				prevNextButtons: true,
				pageDots: false,
				draggable: true,
				wrapAround: true,
				bgLazyLoad: true,
				arrowShape: "M36.3,29.5 L14.6,48.5 C14.2,48.9 14,49.4 14,50 C14,50.5 14.2,51.1 14.6,51.4 L36.3,70.5 L15.3,52 C15.3,52 14.6,51.4 14.6,51.4 C14,50 14,50 14,50 L86.1,50",
				});
		})
	}
	
	document.addEventListener('lazybeforeunveil', function(e){
		var bg = e.target.getAttribute('data-bg');
		if(bg){
			e.target.style.backgroundImage = 'url(' + bg + ')';
		}
	});
	lazySizes.autoSizer.checkElems();

	var checks = document.getElementsByClassName("checkreplacer");
	if(checks.length){
		checks[1].classList.add('gernderMarg');
	}

	if ($('.prev.page-numbers').length) {
		if ($('.next.page-numbers').length) {
			$('.casawp-pagination.pagination').addClass('has-previous');
		}else{
			$('.casawp-pagination.pagination').addClass('has-no-next');
		}
	}

	$('.gallery').lightGallery({
		selector: '.gallery-item a'
	});

	$('.navbar-toggler').on('click', function(){
		if ($(this).hasClass('active-nav')) {
			$(this).removeClass('active-nav');
			$('.navbarOuter').removeClass('nav-bg');
		} else {
			$(this).addClass('active-nav');
			$('.navbarOuter').addClass('nav-bg');
		}
	});

	$('.navbar-collapse').on('shown.bs.collapse', function(){
		$('#footer').hide();
		$('#content').hide();
		$('.sliderOuter').hide();
		$('.navbar-toggler').removeClass('dontClick');
	});

	$('.navbar-collapse').on('show.bs.collapse', function(){
		$('html, body').animate({
			scrollTop: $('html, body').offset().top
		}, 500);
		$('.navbar-toggler').addClass('dontClick');
	});

	$('.navbar-collapse').on('hidden.bs.collapse', function(){
		$('.navbar-toggler').removeClass('dontClick');
	});

	$('.navbar-collapse').on('hide.bs.collapse', function(){
		$('#footer').show();
		$('#content').show();
		$('.sliderOuter').show();
		$('.navbar-toggler').addClass('dontClick');
	});

	$('.preLinkArrow').each(function() {
		this.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 19.02 11"><defs><style>.cls-1{fill:none;stroke:#b4b5b4;stroke-linecap:round;stroke-linejoin:round;}</style></defs><g id="Ebene_2" data-name="Ebene 2"><g id="Ebene_1-2" data-name="Ebene 1"><g id="Page-1"><g id="Mobile_Home" data-name="Mobile Home"><g id="Group-2"><g id="streamline-icon-arrow-down_140x140-_2_" data-name="streamline-icon-arrow-down@140x140-(2)"><line id="Path" class="cls-1" x1="18.42" y1="5.71" x2="0.5" y2="5.68"/><path id="Path-2" data-name="Path" class="cls-1" d="M12.94.5l5.42,4.66a.44.44,0,0,1,.16.34.46.46,0,0,1-.16.34L12.94,10.5"/></g></g></g></g></g></g></svg>';
	});
	
	$('.next.page-numbers').each(function() {
		this.innerHTML = '<svg width="33px" height="20px" viewBox="0 0 33 20" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><title>streamline-icon-arrow-down@140x140 (2)</title><g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round"><g id="streamline-icon-arrow-down@140x140-(2)" transform="translate(16.500000, 10.000000) scale(-1, 1) rotate(90.000000) translate(-16.500000, -10.000000) translate(8.000000, -5.000000)" stroke="#2B2A2A"><line x1="8.81784188" y1="29.8769231" x2="8.7633547" y2="0.0107905983" id="Path"></line><path d="M0,20.7042254 L7.91968182,29.7373299 C8.06637099,29.9043298 8.2774541,30 8.49922727,30 C8.72100045,30 8.93208356,29.9043298 9.07877273,29.7373299 L17,20.7042254" id="Path"></path></g></g></svg>';
	});

	$('.prev.page-numbers').each(function() {
		this.innerHTML = '<svg width="33px" height="20px" viewBox="0 0 33 20" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><title>streamline-icon-arrow-down@140x140 (2)</title><g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round"><g id="streamline-icon-arrow-down@140x140-(2)" transform="translate(16.500000, 10.000000) scale(-1, 1) rotate(90.000000) translate(-16.500000, -10.000000) translate(8.000000, -5.000000)" stroke="#2B2A2A"><line x1="8.81784188" y1="29.8769231" x2="8.7633547" y2="0.0107905983" id="Path"></line><path d="M0,20.7042254 L7.91968182,29.7373299 C8.06637099,29.9043298 8.2774541,30 8.49922727,30 C8.72100045,30 8.93208356,29.9043298 9.07877273,29.7373299 L17,20.7042254" id="Path"></path></g></g></svg>';
	});

	$('.toggleFilter').on('click', function(e) {
		e.preventDefault();
		$('.casawp-archive-filter').toggleClass('showFilter');
		$('.casawp-archive').toggleClass('showFilter');
		return false;
	});

	$('.toggleMap').on('click', function(e){
		e.preventDefault();
		if ($('.map-wrap').hasClass('hideMap')) {
			$('.map-wrap').removeClass('hideMap');
			if ($('#casawp-map').length) {
				/* initializeMapBoxCasaWP(); */
			};
		} else {
			$('.map-wrap').addClass('hideMap');
		}
		return false;
	});

	if ($('.slider').length) {
		var slider = new Flickity('.slider', {
			cellAlign: 'left',
			wrapAround: true,
			imagesLoaded: true,
			pageDots: false,
			prevNextButtons: false,
			draggable: false,
			autoPlay: 4000,
			pauseAutoPlayOnHover: false,
			arrowShape: 'M0,13.4225352 L4.65863636,18.842398 C4.74492411,18.9425979 4.86909064,19 4.99954545,19 C5.13000026,19 5.2541668,18.9425979 5.34045455,18.842398 L10,13.4225352'
		});
	}

	if ($('.testiSlider').length) {
		var testiSlider = new Flickity('.testiSlider', {
			cellAlign: 'left',
			wrapAround: true,
			imagesLoaded: true,
			pageDots: true,
			prevNextButtons: false,
			draggable: true,
			autoPlay: 7000,
			adaptiveHeight: true
		});
	}
	if ($('.listSlider').length) {
		var checkSlider = new Flickity('.listSlider', {
			cellAlign: 'left',
			wrapAround: true,
			imagesLoaded: true,
			pageDots: true,
			prevNextButtons: false,
			draggable: true,
			autoPlay: false,
			adaptiveHeight: true
		});
		var matchheight = 0;
		$('.listItem-wrapper').each(function( index ) {
			if($(this).height() > matchheight){
				matchheight = $(this).height();
			}
		});
		$('.flickity-viewport').css('min-height', matchheight+'px');
	}


	if ($('.casawp-main-flickity').length) {
		var immoSlider = new Flickity('.casawp-main-flickity', {
			cellAlign: 'center',
			autoPlay: 7000,
			draggable: false,
			wrapAround: true,
			pageDots: false,
			imagesLoaded: true,
			prevNextButtons: true,
			arrowShape :"M36.3,29.5 L14.6,48.5 C14.2,48.9 14,49.4 14,50 C14,50.5 14.2,51.1 14.6,51.4 L36.3,70.5 L15.3,52 C15.3,52 14.6,51.4 14.6,51.4 C14,50 14,50 14,50 L86.1,50"
		});
		window.addEventListener( 'load', function() {
			immoSlider.resize();
		});
	}

	$('.casawp-main-flickity').lightGallery({
		selector: '.property-image-gallery',
		download: false,
		thumbnail: false
	});

	//Slider für den Banner Bereich auf jeder Seite, mit Lazyload
	if ($('.slider-outer__slider').length) {
		var slider = new Flickity('.slider-outer__slider', {
			cellAlign: 'left',
			fade: true,
			imagesLoaded: true,
			pageDots: false,
			prevNextButtons: false,
			draggable: false,
			autoPlay: 5000,
			bgLazyLoad: true,
			arrowShape: 'M94.7762777,45.7462648 L96.8509582,45.7462648 L96.8509582,47.5917818 L99.8321434,50.2436733 L96.8509582,52.9263562 L96.8509582,54.080265 L95.5686539,54.080265 L69.2055383,77.8036752 L69.2055383,54.080265 L0,54.080265 L0,45.7462648 L69.2055383,45.7462648 L69.2055383,23 L94.7762777,45.7462648 Z'

		});
	}

	function initializeMapBoxCasaWP() {

		var style = [
			{
				"featureType": "administrative",
				"elementType": "labels.text.fill",
				"stylers": [
				{
					"color": "#444444"
				},
				{
					"gamma": "1"
				}
				]
			},
			{
				"featureType": "administrative.land_parcel",
				"elementType": "labels",
				"stylers": [
				{
					"visibility": "off"
				}
				]
			},
			{
				"featureType": "landscape",
				"stylers": [
				{
					"color": "#f2f2f2"
				}
				]
			},
			{
				"featureType": "landscape",
				"elementType": "labels.text",
				"stylers": [
				{
					"visibility": "simplified"
				}
				]
			},
			{
				"featureType": "poi",
				"elementType": "labels.text",
				"stylers": [
				{
					"visibility": "off"
				}
				]
			},
			{
				"featureType": "poi.business",
				"stylers": [
				{
					"visibility": "off"
				}
				]
			},
			{
				"featureType": "poi.medical",
				"stylers": [
				{
					"visibility": "off"
				}
				]
			},
			{
				"featureType": "poi.sports_complex",
				"stylers": [
				{
					"visibility": "off"
				}
				]
			},
			{
				"featureType": "road",
				"stylers": [
				{
					"saturation": -100
				},
				{
					"lightness": 45
				},
				{
					"visibility": "simplified"
				}
				]
			},
			{
				"featureType": "road",
				"elementType": "labels.icon",
				"stylers": [
				{
					"visibility": "off"
				}
				]
			},
			{
				"featureType": "road.local",
				"elementType": "labels",
				"stylers": [
				{
					"visibility": "off"
				}
				]
			},
			{
				"featureType": "transit",
				"stylers": [
				{
					"visibility": "off"
				}
				]
			},
			{
				"featureType": "transit",
				"elementType": "labels.text",
				"stylers": [
				{
					"visibility": "off"
				}
				]
			},
			{
				"featureType": "water",
				"stylers": [
				{
					"color": "#b4d4e1"
				}
				]
			}
			];

		var mapOptions = {
			center: {lat: 47.247913, lng: 8.674145},
			zoom: 14,
			disableDefaultUI: false,
			zoomControl: true,
			mapTypeControlOptions: {
					mapTypeIds: ['roadmap', 'hybrid']
				},
			styles: style
		};
		var map = new google.maps.Map(document.getElementById('casawp-map'), mapOptions);

		if ($('.casawp-property').length > 0) {
			$('.loadingOverlay').removeAttr('style');
		}
		
		if (!$('.casawp-archive').hasClass('refArchive')) {
			var $form = $('.casawp-filterform');
			var filteredParams = $form.serialize();
			var url = $form.prop('action');
			url = url.replace(window.location.protocol + "//" + window.location.host, '');
			var url_last = window.location.href.split("?");

			var filteredUrl = myAddParameterAndReturn(url + '?' + url_last[1], 'ajax', '1');
			filteredUrl = myAddParameterAndReturn(filteredUrl, 'posts_per_page', '30');
			filteredUrl = myAddParameterAndReturn(filteredUrl, 'json', '1');
			//console.log(filteredUrl);
			requestMarkers(map, '/immobilien/?&availabilities[]=active&salestypes[]=rent&salestypes[]=buy&features=&ajax=1&posts_per_page=30&json=1');

			$('.casawp-filterform').on( "casawp-ajaxfilter:filter-submit", function(event, url, filteredUrl){
				requestMarkers(map, filteredUrl+"&ajax=1&posts_per_page=30&json=1");
			});
		} else {
			requestMarkers(map, '/immobilien/?availabilities%5B%5D=reference&salestypes=&utilities=&categories=&locations=&rooms_from=&rooms_to=&features=&ajax=1&posts_per_page=100&json=1');
		}
	}

	$('.form-group select').parent().append('<i class="fal fa-angle-down"></i>');

	$('.filterOuter .select2').parent().append('<i class="fal fa-angle-down"></i>');

	$('.checkboxoption label').parent().append('<i class="fal fa-check"></i>');

	$('.casawp-filterform .chosen-container-single .chosen-single').append('<i class="fal fa-angle-down"></i>');

	if ($('#casawp-map').length) {
		initializeMapBoxCasaWP();
	};

	if($('.casawp-property').length && $('.nothingFoundWrap').length ){
		var matchheight = 0;
		$('.casawp-property').each(function( index ) {
			if($(this).height() > matchheight){
				matchheight = $(this).height();
			}
		});
		$('.nothingFoundWrap').css('height', matchheight);
	}
	if($('.kachel-inner').length){
		var matchheight = 0;
		$('.kachel-wrapper__kachel-content').each(function( index ) {
			if($(this).height() > matchheight){
				matchheight = $(this).height();
			}
		});
		$('.kachel-inner').css('height', matchheight+130);
	}
	$( window ).on('resize', function() {
		var matchheight = 0;
		$('.kachel-wrapper__kachel-content').each(function( index ) {
			if($(this).height() > matchheight){
				matchheight = $(this).height();
			}
		});
		$('.kachel-inner').css('height', matchheight+130);
	});

	$('.casawp-filterform').on( "casawp-filterform:after-filter-reload", function(event, url, filteredUrl){
		$('.casawp-filterform .chosen-container-single .chosen-single').append('<i class="fal fa-angle-down"></i>');

	});
	$('.casawp-ajax-archive-list').on( "casawp-ajaxfilter:after-list-reload", function(event, url, filteredUrl){
		$('.casawp-filterform .chosen-container-single .chosen-single').append('<i class="fal fa-angle-down"></i>');

		var width = $(window).width(); 
		if (width <= 768) {
		$('html, body').animate({
		scrollTop: $('.contentWrap').offset().top
		}, 1000);
		}
	});
	

	function initializeMap($mapwraper) {
		if ($('.marker').length) {
			var markerIcon = $('.marker').data('marker');
		}
		var location = new google.maps.LatLng($mapwraper.data('lat'),$mapwraper.data('lng'));
		var mapOptions = {
			zoom: parseInt(window.casawpOptionParams.google_maps_zoomlevel),
			mapTypeId: google.maps.MapTypeId.ROADMAP,
			center: location,
			mapTypeControlOptions: {
			mapTypeIds: ['gray_map', google.maps.MapTypeId.SATELLITE]
			}
		};
		$mapwraper.show();
		map = new google.maps.Map(document.getElementById('map-canvas'), mapOptions);

		var marker = new google.maps.Marker({
			map: map,
			position: location,
			icon: new google.maps.MarkerImage(
					markerIcon,
					new google.maps.Size(28,39),
					null,
					null,
					new google.maps.Size(28,39)
				)
		});
		map.mapTypes.set('gray_map',
			new google.maps.StyledMapType([{stylers: [{saturation: -90}]}],
				{name: "Gray Map"}));
		map.setMapTypeId('gray_map');
	}
	
	if ($('.casawp-map').length && google) {
		$('.casawp-map').each(function(){
			var $mapwraper = $(this);
			if ($mapwraper.data('lat') && $mapwraper.data('lng')) {
				//var map;
				if ($('#casawp-mapShowBtn').length) {
					$('#casawp-mapShowBtn').on('click', function() {
						console.log("click");
						if ($('#casawp-mapShowBtn').length) {
							$('#casawp-mapShowBtn').css('display', 'none');
						}
						if ($('.casawp-map__placeholder').length) {
							$('.casawp-map__placeholder').css('display', 'none');
						}
						$('.casawp-map').css('display', 'block');
						initializeMap($mapwraper);
					});
				} else {
					initializeMap($mapwraper);
				}
			}
		});
	}

	if ($("html").attr("lang") == "it-IT") {
		var searching = "Ricerca ...";
		var noresults = "Nessun risultato trovato";
		var shortinput = "Si prega di inserire almeno 3 caratteri";
		var where = "Scegliere il luogo";
	} else if ($("html").attr("lang") == "en-US") {
		var searching = "Search ...";
		var noresults = "No result found";
		var shortinput = "Please enter at least 3 characters";
		var where = "Choose place";
	} else if ($("html").attr("lang") == "fr-FR") {
		var searching = "Recherche ...";
		var noresults = "Aucun résultat trouvé";
		var shortinput = "Veuillez saisir au moins 3 caractères";
		var where = "Choisissez un lieu";
	} else {
		var searching = "Suchen ...";
		var noresults = "Kein Resultat gefunden";
		var shortinput = "Bitte geben Sie mindestens 3 Zeichen ein";
		var where = "Ort wählen";
	}


	$('#searchfieldLocation').select2({
		minimumInputLength: 3,
		allowClear: true, 
		placeholder: where,
		language: {
		  inputTooShort: function () {
			return shortinput;
		  },
		  noResults: function() {
			return noresults;
		  },
		  searching: function() {
			return searching;
		  },
		},
		dropdownAutoWidth: true,
		dropdownParent: $('#searchfieldLocation').parent(),
		ajax: {
			url: 'https://geo.casasoft.com/rpc/tree/search',
			dataType: 'json',
			delay: 250,
			data: function (params) {
				return {
					s: params.term,
					lvl: 'plz'
				};
			},
			processResults: function (data) {
				var locationResults = [];
				$.each(data.nodes, function(index, elem){
					locationResults.push({
						"id": elem.id,
						"data_lat": elem.lat,
						"data_lng": elem.lng,
						"data_plz": elem.postalCode,
						"data_locality": elem.locality,
						"text": `${elem.postalCode} ${elem.locality}`
					})
				})
			  return {
				results: locationResults
			  };
			},
		}
	});

	$('#searchfieldLocation').one('select2:open', function(e) {
		$('input.select2-search__field').prop('placeholder', searching);
	});

	$('#searchfieldLocation').on('select2:clearing', function (e) {
	  $('input[name="searchProfile_postal_code"]').val(null);
	  $('input[name="searchProfile_locality"]').val(null);
	  $('input[name="filter_location_label"]').val(null);
	});

	$('#searchfieldLocation').on("change", function(){
		var data = $(this).select2('data')[0];
		if (data != null) {
			var plz = data.data_plz;
			var locality = data.data_locality;
			$('input[name="searchProfile_postal_code"]').val(plz);
			$('input[name="searchProfile_locality"]').val(locality);
			$('input[name="filter_location_label"]').val(data.text);
		}
	});

	$('#contactFormcountry').select2({
		//placeholder: selectlabel,
		dropdownParent: $("#contactFormcountry").parent(),
		//minimumResultsForSearch: Infinity,
		width: "100%"
	});

});



// WEBPACK FOOTER //
// ./src/js/main.js